// extracted by mini-css-extract-plugin
export default {"viewSwitcher":"styles_viewSwitcher__zGAhA","icon":"styles_icon__Z9C99","viewSwitcherDropdown":"styles_viewSwitcherDropdown__NFBQK","option":"styles_option__3iwX-"};